import { StructureSearchResult } from '@/types/search-result';
import { http } from './http.service';
class StructureSearchService {
  structureToNumber = async (parameter: { exactSearch: 'true' | 'false'; mrv: string }) => {
    const response = await http.post<{ casNumberList?: string; exactSearch?: boolean }>(
      `/api/search/struct/structToNumber`,
      parameter
    );
    return response;
  };
  structureSearch = async (parameter: {
    language: string;
    country: string;
    casNumberList: string;
    pageNo: number;
    pageSize: number;
    filter?: string;
    gpt?: string;
    sortOrder: 'asc' | 'desc';
  }) => {
    const response = await http.post<StructureSearchResult>(`/api/search/struct/search`, {
      ...parameter,
      exactSearch: false,
    });
    return response;
  };
}

export const structureSearchService = new StructureSearchService();
